import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

// Iter 722 (Kamel) — lien court par voyage : /algerie, /turin… → page du voyage, visite comptée (?s=tiktok…&c=campagne) ; inconnu → accueil
export default function GoSlug() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const s = params.get('s') || 'bio';
    const c = params.get('c');
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/go/${encodeURIComponent(slug)}/info`)
      .then(r => { if (r.ok) window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/go/${encodeURIComponent(slug)}?s=${encodeURIComponent(s)}${c ? `&c=${encodeURIComponent(c)}` : ''}`); else navigate('/', { replace: true }); })
      .catch(() => navigate('/', { replace: true }));
  }, [slug, params, navigate]);
  return null;
}
